
import {
  ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges
} from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { AssessmentLevelsService } from 'assessment/assessment-levels.service';
import { AssessmentInfoViewModel } from 'assessment/AssessmentInfoViewModel';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-assessment-circle',
  template: `
  <ng-container *ngIf="avm">
       <span class="avatar" [ngClass]="['avatar--a' + avm?.color, 'avatar--' + size || 'md']" title="{{avm.description}}">
       <span class="avatar__assessment">{{avm?.level || '–'}}</span>
       </span>
   </ng-container> `
})
export class AssessmentCircleComponent extends WithDisposableSubject() implements OnDestroy, OnChanges, OnInit {
  @Input() level: number;
  @Input() size = 'md';
  @Input() entityTypeId: string; // required

  avm: AssessmentInfoViewModel;

  _changeSubject = new Subject<number>();

  /**
   *
   */
  constructor(
    private _assessmentLevelService: AssessmentLevelsService,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this._changeSubject.pipe(
      takeUntil(this.disposer),
      startWith(this.level),
      distinctUntilChanged(),
      switchMap(level => this._assessmentLevelService.getAssessmentInfoVM(level, this.entityTypeId))
    ).subscribe((vm) => {
      this.avm = vm;
      this._cd.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['level'];
    if (change) {
      this._changeSubject.next(change.currentValue);
    }
  }
}
